export default __webpack_public_path__ + "static/media/review-checkout-icon.d2184068.svg";